module.exports = __webpack_public_path__ + "media/altfee/symbol-defs-941f2590.svg";